import { Injectable } from '@angular/core';
import { DialogService } from '@mode/shared/ui';

import { TableCalcDialogData, TableCalcDialogComponent } from './table-calc-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class TableCalcDialogService {
  constructor(private dialogService: DialogService) {}

  public open(data: TableCalcDialogData): void {
    this.dialogService.open({
      component: TableCalcDialogComponent,
      matDialogConfig: {
        backdropClass: 'mode-table-calc-dialog-backdrop',
        width: '472px',
        data,
      },
    });
  }
}
